const QUESTIONNAIRES = {
    content: 'questionnaire',
    filter: [
        'profile',
        'event'
    ]
}

import hasCount from './util/has-count'

export default {
    option: {
        value: 'questionnaire',
        label: 'Questionnaire',
        show: true,

        children: [
            {
                value: 'completed',
                label: 'Has responded to',
                select: QUESTIONNAIRES,

                match: hasCount({ type: 'questionnaire' })
            },
            {
                value: 'not-completed',
                label: 'Has not responded to',
                select: QUESTIONNAIRES,

                match: hasCount({ type: 'questionnaire', not: true })
            }
        ]
    }
}
